export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20warm%20amber%20and%20golden%20tones%20featuring%20flowing%20film%20strips%20and%20soft%20bokeh%20light%20effects%20on%20a%20dark%20warm%20background%2C%20artistic%20stylized%20movie%20theater%20atmosphere%20with%20subtle%20lens%20flare%2C%20elegant%20cinematic%20visual%20for%20a%20movie%20streaming%20platform%2C%20no%20text%2C%20clean%20composition%2C%20rich%20warm%20gradients&width=1600&height=900&seq=hero-cinema-01&orientation=landscape"
          alt="午马影院高清影视平台主视觉"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 via-background-950/40 to-background-950/20"></div>

      <div className="relative w-full z-10 px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/15 text-accent-600 text-sm font-medium mb-4">
              每日更新 · 海量资源
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-3">
              午马影院
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-300 mt-1">
                高清流畅免费在线影院
              </span>
            </h1>

            <p className="text-lg md:text-xl text-background-200/90 font-light mt-4 leading-relaxed max-w-xl lg:max-w-none">
              即点即播、无需注册的高清影视平台。涵盖最新院线大片、热播电视剧、人气综艺、经典动漫等数万部资源，每日持续更新。
              采用智能加速技术，确保播放流畅不卡顿，画质清晰细腻，为您带来沉浸式观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mt-5">
              <div className="flex items-center gap-2 text-background-100/80">
                <span className="w-8 h-8 flex items-center justify-center text-accent-400">
                  <i className="ri-fire-line text-lg"></i>
                </span>
                <span className="text-sm">日更新 200+ 部</span>
              </div>
              <div className="flex items-center gap-2 text-background-100/80">
                <span className="w-8 h-8 flex items-center justify-center text-accent-400">
                  <i className="ri-film-line text-lg"></i>
                </span>
                <span className="text-sm">30000+ 资源库</span>
              </div>
              <div className="flex items-center gap-2 text-background-100/80">
                <span className="w-8 h-8 flex items-center justify-center text-accent-400">
                  <i className="ri-speed-up-line text-lg"></i>
                </span>
                <span className="text-sm">极速秒播不卡顿</span>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-6">
              <a
                href="#cards"
                onClick={(e) => handleScroll(e, '#cards')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-background-200/60 text-background-50 font-semibold rounded-lg hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20golden%20and%20amber%20lighting%2C%20abstract%20film%20elements%20floating%20in%20space%2C%20soft%20theatrical%20glow%2C%20elegant%20dark%20warm%20background%20with%20subtle%20grain%20texture%2C%20artistic%20movie%20poster%20aesthetic%2C%20clean%20composition%20with%20negative%20space&width=800&height=600&seq=hero-visual-02&orientation=landscape"
                alt="午马影院沉浸式观影体验"
                className="w-full h-full object-cover rounded-xl"
              />
              <div className="absolute inset-0 rounded-xl border border-background-200/20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}